import { COMMON_ANALYTICS_ATTRIBUTES as BASE_COMMON_ANALYTICS_ATTRIBUTES } from '../../common/constants.tsx';

export const COMMON_ANALYTICS_ATTRIBUTES = {
	...BASE_COMMON_ANALYTICS_ATTRIBUTES,
	section: 'integrations',
};
